<div class="p-4">
  <h2 class="text-xl font-semibold mb-4 text-red-600">Store-wise Monthly Sales</h2>

  <ngx-charts-bar-vertical
    [results]="chartData"
    [xAxis]="showXAxis"
    [yAxis]="showYAxis"
    [showXAxisLabel]="showXAxisLabel"
    [showYAxisLabel]="showYAxisLabel"
    [gradient]="gradient"
    [roundEdges]="true"
    [animations]="true"
    [scheme]="colorScheme"
    [xAxisLabel]="xAxisLabel"
    [yAxisLabel]="yAxisLabel">
  </ngx-charts-bar-vertical>
</div>
